
export class GetMergeModelData {
    static readonly type = '[mergeModel] get merge model data';
  
    constructor(public payload: any) {
    }
  }
  